import React from 'react'

const ScrollAni = () => {
  return (
    <div className="scroll-arrow">
      <i></i>
      <i></i>
      <i></i>
    </div>
  )
}

export default ScrollAni